( () => {
  const EXTRA_GAP = -1;
  let suppressHashchangeHandler = false;
  let cachedHeaderHeight = 0;

  const captureHeaderHeight = () => {
    const header = document.querySelector( 'header' );
    const fullHeight = header?.offsetHeight || 0;
    const topNavH = getComputedStyle( document.documentElement ).getPropertyValue( '--topNavH' );
    cachedHeaderHeight = fullHeight - ( parseInt( topNavH, 10 ) || 0 );
  };

  const getScrollOffset = () => {
    const adminBar = document.getElementById( 'wpadminbar' );
    return cachedHeaderHeight + ( adminBar?.offsetHeight || 0 ) + EXTRA_GAP;
  };

  const decodeHash = ( rawId ) => {
    try {
      return decodeURIComponent( rawId );
    } catch ( _e ) {
      return rawId;
    }
  };

  const getTargetFromHash = ( hash = window.location.hash ) => {
    if ( !hash || hash === '#' ) return null;

    const rawId = hash.startsWith( '#' ) ? hash.slice( 1 ) : hash;
    if ( !rawId ) return null;

    const byId = document.getElementById( decodeHash( rawId ) );
    if ( byId ) return byId;

    try {
      return document.querySelector( hash );
    } catch ( _e ) {
      return null;
    }
  };

  const scrollToTarget = ( target, behavior = 'auto' ) => {
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    const top = Math.max( 0, target.getBoundingClientRect().top + scrollY - getScrollOffset() );
    window.scrollTo( { top, behavior } );
  };

  const correctHashPosition = ( behavior = 'auto' ) => {
    const target = getTargetFromHash();
    if ( !target ) return;
    scrollToTarget( target, behavior );
  };

  const isSkippableAnchor = ( anchor ) =>
    !anchor ||
    ( anchor.target && anchor.target !== '_self' ) ||
    anchor.hasAttribute( 'download' ) ||
    anchor.dataset.bsToggle ||
    anchor.dataset.toggle ||
    anchor.getAttribute( 'role' ) === 'tab';

  const parseSamePageHash = ( anchor ) => {
    const href = anchor.getAttribute( 'href' ) || '';
    if ( !href || href === '#' || !href.includes( '#' ) ) return null;

    let parsed;
    try {
      parsed = new URL( href, window.location.href );
    } catch ( _e ) {
      return null;
    }

    const isSamePage =
      parsed.origin === window.location.origin &&
      parsed.pathname === window.location.pathname &&
      parsed.search === window.location.search &&
      parsed.hash && parsed.hash !== '#';

    return isSamePage ? parsed.hash : null;
  };

  const shouldHandleAnchorClick = ( anchor ) => {
    if ( isSkippableAnchor( anchor ) ) return false;
    const hash = parseSamePageHash( anchor );
    return hash ? !!getTargetFromHash( hash ) : false;
  };

  const onDocumentClick = ( event ) => {
    const anchor = event.target.closest( 'a[href*="#"]' );
    if ( !shouldHandleAnchorClick( anchor ) ) return;

    const hash = new URL( anchor.getAttribute( 'href' ), window.location.href ).hash;

    event.preventDefault();
    suppressHashchangeHandler = true;
    history.pushState( null, '', hash );
    correctHashPosition( 'smooth' );
    window.setTimeout( () => {
      suppressHashchangeHandler = false;
    }, 0 );
  };

  const onHashchange = () => {
    if ( suppressHashchangeHandler ) return;
    correctHashPosition( 'auto' );
  };

  const init = () => {
    captureHeaderHeight();

    // Tell the browser to offset ALL native hash scrolls by the header height.
    // This prevents the visible "jump to top then correct" on Enter press.
    document.documentElement.style.scrollPaddingTop = getScrollOffset() + 'px';

    document.addEventListener( 'click', onDocumentClick );
    window.addEventListener( 'hashchange', onHashchange );

    if ( window.location.hash ) {
      window.setTimeout( () => correctHashPosition( 'auto' ), 500 );
    }
  };

  document.addEventListener( 'DOMContentLoaded', init );
} )();
